<div mat-dialog-title>
  <div class="df ac jsb f1">
    <div class="df ac">
      <T
        class="amrs"
        str="Add field"></T>
    </div>
    <div>
      <button
        mat-icon-button
        (click)="ref.close()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-dialog-content class="df c">
  <apex-select-field
    [folder]="folder"
    [parentFolder]="parentFolder"
    (fieldId)="emitFieldId($event)"></apex-select-field>
</mat-dialog-content>
<mat-dialog-actions>
  <div></div>
  <div>
    <button
      mat-button
      (click)="ref.close()">
      <T str="Cancel"></T>
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="save()">
      <T str="Save"></T>
    </button>
  </div>
</mat-dialog-actions>
